import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { GROUP_TYPE, GROUP_TYPE_LABEL } from 'constants/groups';

import { useGroupsContext } from '../GroupsContext';

const GroupsFiltersType = () => {
  const { filters, setFilters } = useGroupsContext();

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, type: values });
  };

  const options = [
    {
      label: GROUP_TYPE_LABEL[GROUP_TYPE.DEFAULT],
      value: GROUP_TYPE.DEFAULT,
    },
    {
      label: GROUP_TYPE_LABEL[GROUP_TYPE.COMPANY],
      value: GROUP_TYPE.COMPANY,
    },
    {
      label: GROUP_TYPE_LABEL[GROUP_TYPE.HOLDING],
      value: GROUP_TYPE.HOLDING,
    },
  ];

  return (
    <SelectAdvancedFilter
      className={classNames({ active: Boolean(filters.type?.length) })}
      placeholder={'Type'}
      options={options}
      defaultValue={filters?.type ?? []}
      onSelect={handleSelect}
    />
  );
};

export default GroupsFiltersType;
